import { render, staticRenderFns } from "./page-panel.vue?vue&type=template&id=548d5a8b"
import script from "./page-panel.vue?vue&type=script&lang=js"
export * from "./page-panel.vue?vue&type=script&lang=js"
import style0 from "./page-panel.vue?vue&type=style&index=0&id=548d5a8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports